export const baseApi = "https://api.asm.easyeco.prod.emberware.it/wp-json/ee/v1"
